// extracted by mini-css-extract-plugin
export var burger = "nav-module--burger--c2e39";
export var buyBtn = "nav-module--buyBtn--e9aa6";
export var isDropdown = "nav-module--isDropdown--e63dc";
export var logo = "nav-module--logo--6e027";
export var mask = "nav-module--mask--bc12a";
export var menuList = "nav-module--menuList--6b247";
export var mobileNav = "nav-module--mobileNav--1cbf0";
export var nav = "nav-module--nav--b7415";
export var right = "nav-module--right--b7f39";
export var visible = "nav-module--visible--cc3e6";